import React from 'react';

import { Select } from '@aline/common';
import { IconButton, Typography } from '@mui/material';
import { AddWorkflowFilesButton, AlineTooltip } from 'src/components';
import { BackArrowIcon } from 'src/components/icons/BackArrowIcon';
import { IconColors } from 'src/components/icons/icon-utils';
import { useCheckWorkflowAuthorization, useGetWorkflowSimple } from 'src/hooks';
import { getWorkflowWasSentForSig } from 'src/workflow';
import { makeStyles } from 'tss-react/mui';

import type { OutlineMenuViewProps } from './types';

const useStyles = makeStyles()(() => ({
  addDocumentButton: {
    padding: '2px',
  },
  root: {
    alignItems: 'center',
    display: 'flex',
    gap: '4px',
    marginBottom: '4px',
    paddingRight: '3px',
  },
  workflowTitle: {
    fontSize: '12px',
    fontWeight: 700,
    marginRight: 'auto',
  },
}));

interface Props extends Pick<OutlineMenuViewProps, 'handleClose'> {
  isWorkflow: boolean;
  workflowId: string | null;
}

export const OutlineMenuHeader: React.FC<Props> = ({ handleClose, isWorkflow, workflowId }) => {
  const { classes } = useStyles();
  const { workflow } = useGetWorkflowSimple(workflowId);
  const workflowSentForSig = getWorkflowWasSentForSig(workflow);
  const { canEditWorkflow } = useCheckWorkflowAuthorization(workflowId);

  return (
    <div className={classes.root}>
      <AlineTooltip arrow placement="right" title="Hide outline">
        <IconButton
          aria-label="Hide outline"
          color="primary"
          data-cy={Select.document.leftOutline.closeOutlineButton}
          size="small"
          sx={{ color: theme => theme.appColors.iconsType }}
          onClick={handleClose}
        >
          <BackArrowIcon
            sx={{
              height: 18,
              width: 18,
            }}
          />
        </IconButton>
      </AlineTooltip>
      <Typography className={classes.workflowTitle}>
        {isWorkflow ? 'Workflow documents' : 'Document outline'}
      </Typography>
      {isWorkflow && workflowId && !workflowSentForSig && canEditWorkflow && (
        <AlineTooltip arrow placement="right" title="Add document">
          <div>
            <AddWorkflowFilesButton
              dense
              buttonVariant="icon"
              dataCy={Select.workflow.detail.documents.addDocumentButton}
              stroke={IconColors.Primary}
              workflowId={workflowId}
            />
          </div>
        </AlineTooltip>
      )}
    </div>
  );
};
